var map = {
	"./1.png": "d4e5",
	"./2.png": "3e0f",
	"./3.png": "fcfc",
	"./4.png": "e55c",
	"./5.png": "4725",
	"./6.png": "706f",
	"./7.png": "8fa0",
	"./8.png": "13d9",
	"./cover.png": "9d89"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ada6";